// Phase 2 — Admin landing page.
//
// Single destination (`/admin`) for every admin-only tool. Today it
// hosts just the API Keys card; future admin surfaces (per-user roles,
// system audit, feature flags…) slot in next to it with the same card
// shape so the gear-icon workflow stays stable for the operator.
//
// Deliberately NOT a dashboard — no stats, no widgets. Just a clean
// hub that routes to the actual tools.

import { Link } from "react-router-dom";
import { KeyRound, ChevronRight } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const ADMIN_TOOLS = [
  {
    to: "/admin/api-keys",
    testid: "admin-tool-api-keys",
    icon: KeyRound,
    title: "API Keys",
    description:
      "Create and revoke bearer tokens that the MCP server and REST tool mirror " +
      "will use to authenticate Claude and other AI assistants.",
  },
];

export default function AdminLanding() {
  return (
    <div className="space-y-8" data-testid="admin-landing">
      <header className="space-y-1">
        <h1 className="text-3xl font-semibold tracking-tight">Admin</h1>
        <p className="text-sm text-neutral-600">
          Operator-only tools. Changes here affect the whole workspace.
        </p>
      </header>

      <section className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {ADMIN_TOOLS.map(({ to, testid, icon: Icon, title, description }) => (
          <Link
            key={to}
            to={to}
            data-testid={testid}
            className="group block focus:outline-none focus-visible:ring-2 focus-visible:ring-brand rounded-lg"
          >
            <Card className="h-full transition-colors hover:border-brand hover:shadow-sm">
              <CardHeader className="flex flex-row items-start justify-between space-y-0 pb-2">
                <div className="flex items-center gap-2">
                  <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-brand-muted text-brand">
                    <Icon className="h-5 w-5" />
                  </span>
                  <CardTitle className="text-base">{title}</CardTitle>
                </div>
                <ChevronRight className="h-4 w-4 text-neutral-400 transition-colors group-hover:text-brand" />
              </CardHeader>
              <CardContent>
                <CardDescription className="text-sm leading-relaxed">
                  {description}
                </CardDescription>
              </CardContent>
            </Card>
          </Link>
        ))}
      </section>
    </div>
  );
}
